<mat-tab-group
  [selectedIndex]="selectedTypeIndex.value"
  (selectedIndexChange)="selectedTypeIndex.setValue($event)"
  (selectedTabChange)="onTypeChange()"
>
  <mat-tab
    [label]="'igo.geo.spatialFilter.predefined' | translate"
    id="spatial-filter-predefined-tab"
  >
    <mat-form-field id="spatial-filter-field-type">
      <mat-label>{{
        'igo.geo.spatialFilter.searchLabel' | translate
      }}</mat-label>
      <mat-select
        (selectionChange)="onSelectionChange()"
        [(value)]="selectedQueryType"
      >
        @for (queryType of queryType; track queryType) {
          <mat-option [value]="queryType">
            {{ 'igo.geo.terrapi.' + queryType | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <igo-spatial-filter-list
      [store]="store()"
      [queryType]="selectedQueryType()"
      (addZone)="addZone.emit($event)"
      (removeZone)="removeZone.emit($event)"
      (zonesWithBufferChange)="zonesWithBufferChange.emit($event)"
      (bufferChange)="bufferChange.emit($event)"
      (measureUnitChange)="measureUnitChange.emit($event)"
    />
  </mat-tab>

  <mat-tab
    [label]="'igo.geo.spatialFilter.draw' | translate"
    id="spatial-filter-draw-tab"
  >
    <div class="spatial-type-toggle">
      <mat-button-toggle-group
        [value]="activeDrawType"
        (change)="onDrawTypeChange($event.value)"
      >
        <mat-button-toggle
          [value]="spatialType.Polygon"
          [matTooltip]="'igo.geo.spatialFilter.drawPolygon' | translate"
        >
          <mat-icon>pentagon</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          [value]="spatialType.Point"
          [matTooltip]="'igo.geo.spatialFilter.drawCircle' | translate"
        >
          <mat-icon>circle</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </mat-tab>
</mat-tab-group>
